export { th } from '@payloadcms/translations/languages/th'
